import React from 'react';
import {Col, Image} from 'react-bootstrap';

import configs from '../../Config.json';



function SeleccionPaises(props){
    const  { varPais } = props;

    /*var varPais = window.location.pathname == '/' ? '/SV/': window.location.pathname;*/

    return(
            <Col className="d-none d-lg-block d-xl-block clubes--seleccion-paises clubes--nav-item">
                <div className="d-flex justify-content-end">
                    { (varPais === configs[0].paisSV) ? <Image className="clubes--image-flag" style={{width:"33px"}} src="https://siman.vtexassets.com/arquivos/elsalvador.png" fluid></Image>
                                    : null

                    }                  
                    { (varPais === configs[0].paisGT) ? <Image style={{width:"30px"}} src="https://siman.vtexassets.com/arquivos/guatemala.png" fluid></Image>
                                    : null

                    }  
                    { (varPais === configs[0].paisCR) ? <Image style={{width:"30px"}} src="https://siman.vtexassets.com/arquivos/costarica.png" fluid></Image>
                                    : null

                    }  
                    { (varPais === configs[0].paisNI) ? <Image style={{width:"30px"}} src="https://siman.vtexassets.com/arquivos/nicaragua.png" fluid></Image>
                                    : null

                    }
                </div> 
            </Col>
        );    
}

export default SeleccionPaises;